<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        [text]="deviceService.isMobile ? '' : 'Back to search'"
        defaultHref="explore"
        (click)="goBack()"
      ></ion-back-button>
    </ion-buttons>

    <div class="SCWEB-address-container" (click)="openAddress($event)" *ngIf="!userService.isBusiness">
      <p>
        {{userService.user ? (userService.user.address ? (userService.user.address | addressShort) : 'Select an
        address') : 'Select an address'}}
      </p>
      <ion-icon name="md-create"></ion-icon>
    </div>
  </ion-toolbar>
</ion-header>

<img class="right-oval" src="assets/img/ovals/grey-oval-right.png" *ngIf="barber && showOval" />

<ion-content>
  <div class="loading-container" *ngIf="!barber">
    <ion-spinner></ion-spinner>
  </div>

  <div *ngIf="barber">
    <div class="left-panel">
      <div class="profile-container">
        <img [src]="barber.pic || placeholderImg" class="prof-pic" alt="{{barber.fullName}} profile picture" />
        <span class="prof-name"> {{barber.fullName}} </span>
        <ion-icon
          class="heart-icon"
          name="{{isFavorited ? 'heart' : 'heart-outline'}}"
          (click)="toggleFavoriteBarber()"
        ></ion-icon>

        <ion-row class="stats">
          <ion-col class="prof-stat">
            <ion-icon name="star" color="gold"></ion-icon>
            <p *ngIf="barber?.numRatings > 5">{{roundToNearestHundredth(barber?.averageRating)}} out of 5</p>
            <p *ngIf="barber?.numRatings <= 5">{{barber?.availableToBook ? 'Book now' : 'Coming soon'}}</p>
          </ion-col>
          <ion-col class="prof-stat" *ngIf="!eventID">
            <ion-icon name="navigate-circle-outline" color="red"></ion-icon>
            <p>{{ barber.cityState || 'No location set' }}</p>
          </ion-col>
          <ion-col class="prof-stat" *ngIf="eventID">
            <ion-icon name="people" color="grey"></ion-icon>
            <p *ngIf="barber?.numRatings > 0">{{barber?.numRatings}} reviews</p>
            <p *ngIf="barber?.numRatings == 0">No reviews yet</p>
          </ion-col>
          <ion-col class="prof-stat stat-clickable" *ngIf="!eventID" (click)="openServices()">
            <ion-icon name="cut"></ion-icon>
            <p>View services</p>
          </ion-col>
        </ion-row>

        <!-- VIP section -->

        <div *ngIf="barber?.vip" class="vip-section">
          <hr />
          <div class="content-container">
            <img src="assets/img/vip_badge.png" class="vip-icon" />
            <span class="vip-text">{{barber?.firstName.toUpperCase()}} IS A TOP PRO</span>
          </div>
        </div>

        <hr />

        <!-- Business section -->

        <div *ngIf="barber?.businessLocationName" class="vip-section">
          <div class="business-content-container">
            <img class="business-icon" *ngIf="barber.businessPic" [src]="barber.businessPic" />
            <span class="business-details">
              <span class="business-name"
                >{{barber.businessLocationName}}<span
                  *ngIf="barber.businessLocationCityState"
                  class="business-city-state"
                  >, {{barber.businessLocationCityState}}</span
                ></span
              >
              <span class="business-info">Certified local {{barber.proType}} Pro from {{barber.businessName}}.</span>
            </span>
          </div>
          <hr />
        </div>

        <div class="panel-embedded">
          <div class="right-panel" *ngIf="!userService.isBusiness && !deviceService.isMobile">
            <div class="booking-module">
              <div class="info-header">Book {{barber.firstName}}</div>
              <div class="info-details">
                <span class="info-name">{{barber.fullName}}</span>
                <span class="info-stars">
                  <ion-icon
                    name="star"
                    [ngClass]="barber.numRatings <= 3 ? 'stars-less-opaque' : ''"
                    *ngFor="let _ of toRange(roundedRating())"
                  ></ion-icon>
                </span>
              </div>

              <div *ngIf="eventID && eventInfo">
                <!-- EVENT -->

                <div class="info-time">
                  <span class="info-event-name">{{eventInfo.name}}</span>
                </div>

                <div class="info-time">{{ displayDate(eventInfo.startTime) }}</div>

                <div *ngIf="eventSelectedService">
                  <div class="selector hover-red" (click)="openServices()">
                    <ion-item lines="none">
                      <ion-icon slot="start" name="cut" color="lightgrey" class="start-icon"></ion-icon>
                      <ion-label>
                        {{ eventSelectedService ? eventSelectedService.serviceTitle : 'Select a service' }}
                      </ion-label>
                      <ion-icon slot="end" name="chevron-down-outline" class="dropdown-arrow"></ion-icon>
                    </ion-item>
                  </div>
                </div>

                <div class="info-time" *ngIf="eventSelectedService && (!eventTimeslots || !eventTimeslots.length)">
                  <hr />
                  No timeslots available for this service.<br />
                  <span class="join-waitlist" (click)="joinWaitlist()">Join our waitlist</span> for updates.
                </div>

                <div *ngIf="eventTimeslots && eventTimeslots.length">
                  <div class="timeslots">
                    <ion-card
                      *ngFor="let timeslot of eventTimeslots"
                      class="time-card"
                      (click)="eventTimeslotPressed(timeslot)"
                      [ngClass]="eventSelectedTimeslot.startTime == timeslot.startTime ? 'highlighted-time-card' : ''"
                    >
                      <ion-card-content>
                        <ion-icon name="lock" *ngIf="timeslot.locked"></ion-icon>
                        <p>{{ getDisplayStringForTimeslotDate(timeslot.startTime) }}</p>
                      </ion-card-content>
                    </ion-card>
                  </div>
                </div>

                <div *ngIf="eventSelectedService && eventTimeslots && eventTimeslots.length" class="book-button">
                  <ion-button
                    color="marine"
                    (click)="bookEventPressed()"
                    class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall"
                    style="text-transform: none"
                    >Select and continue</ion-button
                  >
                </div>

                <div *ngIf="!eventSelectedService" class="book-button">
                  <ion-button
                    color="marine"
                    (click)="openServices()"
                    class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall"
                    style="text-transform: none"
                    >Select a service</ion-button
                  >
                </div>
              </div>

              <div *ngIf="!eventID">
                <!-- IN HOME -->
                <div class="info-time" *ngIf="barber.active && displayTimeslots">
                  {{ displayDate(apptCreator.apptTime.date) }} at {{
                  getDisplayStringForTimeslotDate(apptCreator.apptTime.date) }}
                </div>
                <div class="info-time" *ngIf="barber.active && !displayTimeslots">Available for services</div>
                <div class="unavailable-text" *ngIf="!barber.active">
                  {{barber.firstName}} is unavailable for services at this time. Please check back soon.
                </div>

                <div *ngIf="barber.active && displayTimeslots">
                  <div class="selector hover-red" (click)="openServices()">
                    <ion-item lines="none">
                      <ion-icon slot="start" name="cut" color="lightgrey" class="start-icon"></ion-icon>
                      <ion-label>
                        {{ apptCreator.selectedServiceTypeList.items.length ? apptCreator.selectedServiceTypeList.text :
                        'Select a service' }}
                      </ion-label>
                      <ion-icon slot="end" name="chevron-down-outline" class="dropdown-arrow"></ion-icon>
                    </ion-item>
                  </div>

                  <div class="selector" [ngClass]="datePickerOpen ? '' : 'hover-red'">
                    <ion-item lines="none" (click)="changeAvailDate()">
                      <ion-icon slot="start" name="calendar" color="lightgrey" class="start-icon"></ion-icon>
                      <ion-label> {{ displayDate(selectedTimeslotDate) }} </ion-label>
                      <ion-icon slot="end" name="chevron-down-outline" class="dropdown-arrow"></ion-icon>
                    </ion-item>

                    <div class="selector-date-options" *ngIf="datePickerOpen">
                      <ion-item lines="none" (click)="closeDatePicker()" class="active-date">
                        <ion-icon slot="start" name="calendar" color="lightgrey" class="start-icon"></ion-icon>
                        <ion-label> {{ displayDate(selectedTimeslotDate) }} </ion-label>
                        <ion-icon slot="end" name="chevron-down-outline" class="dropdown-arrow"></ion-icon>
                      </ion-item>

                      <div class="date-options">
                        <div *ngFor="let date of availData.dates" (click)="selectAvailDate(date)">
                          <ion-item
                            lines="none"
                            [ngClass]="datesEqual(selectedTimeslotDate, date) ? 'date-selected' : ''"
                          >
                            <ion-label> {{ displayDate(date) }} </ion-label>
                            <ion-icon
                              slot="end"
                              name="checkmark"
                              class="checkmark-icon"
                              *ngIf="datesEqual(selectedTimeslotDate, date)"
                            ></ion-icon>
                          </ion-item>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="custom-address-container" *ngIf="showCustomAddress">
                    <ion-icon name="home" class="inline"></ion-icon>
                    <p>{{ availData.customAddress | address }}</p>
                  </div>

                  <div class="timeslots">
                    <ion-card
                      *ngFor="let timeslot of displayTimeslots"
                      class="time-card"
                      (click)="availTimeslotPressed(timeslot)"
                      [ngClass]="apptCreator.apptTime.date == timeslot.date ? 'highlighted-time-card' : ''"
                    >
                      <ion-card-content>
                        <ion-icon name="lock" *ngIf="timeslot.locked"></ion-icon>
                        <ion-icon name="pin" *ngIf="timeslot.unavailableInZip"></ion-icon>
                        <ion-icon name="home" *ngIf="timeslot.useCustomAddress"></ion-icon>
                        <p>{{ getDisplayStringForTimeslotDate(timeslot.date) }}</p>
                      </ion-card-content>
                    </ion-card>
                  </div>
                </div>

                <span *ngIf="barber.active && apptCreator.selectedServiceTypeList.items.length">
                  <div *ngIf="!apptCreator.address.zip.length" class="book-button">
                    <ion-button
                      color="marine"
                      (click)="openAddress($event)"
                      class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall"
                      style="text-transform: none"
                      >Please enter your address</ion-button
                    >
                  </div>

                  <div
                    *ngIf="apptCreator.address.zip.length && !displayTimeslots && !userService.isBusiness"
                    class="book-button"
                  >
                    <ion-button
                      color="marine"
                      (click)="goToChat()"
                      class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall"
                      style="text-transform: none"
                      >Chat with {{barber?.firstName}} to book</ion-button
                    >
                  </div>

                  <div *ngIf="apptCreator.address.zip.length && displayTimeslots" class="book-button">
                    <ion-button
                      color="marine"
                      (click)="bookPressed()"
                      class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall"
                      style="text-transform: none"
                      >Select and continue</ion-button
                    >
                  </div>
                </span>

                <span *ngIf="barber.active && !apptCreator.selectedServiceTypeList.items.length">
                  <div class="book-button">
                    <ion-button
                      color="marine"
                      (click)="openServices()"
                      class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall"
                      style="text-transform: none"
                      >Select a service</ion-button
                    >
                  </div>
                </span>
              </div>
            </div>
          </div>

          <div class="right-panel" *ngIf="!userService.isBusiness && deviceService.isMobile">
            <div class="booking-module">
              <div class="info-header">Book {{barber.firstName}}</div>
              <div class="info-details" *ngIf="!eventID">
                <span class="info-name">{{barber.fullName}}</span>
                <span class="info-stars">
                  <ion-icon
                    name="star"
                    [ngClass]="barber.numRatings <= 3 ? 'stars-less-opaque' : ''"
                    *ngFor="let _ of toRange(roundedRating())"
                  ></ion-icon>
                </span>
              </div>
              <div class="info-event-details" *ngIf="eventID && eventInfo">
                <span class="info-event-name">{{eventInfo.name}}</span>
              </div>
              <div class="unavailable-text" *ngIf="!barber.active">
                {{barber.firstName}} is unavailable for services at this time. Please check back soon.
              </div>

              <span *ngIf="barber.active">
                <div class="book-button">
                  <ion-button
                    color="marine"
                    (click)="openAppLink()"
                    class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall"
                    style="text-transform: none"
                    >Book {{barber?.firstName}} in Shortcut</ion-button
                  >
                </div>
              </span>
            </div>
          </div>

          <!-- BUSINESS PRO SETTINGS -->
          <div class="right-panel" *ngIf="userService.business">
            <div class="booking-module" *ngIf="barber.businessID !== userService.business.id">
              <div class="info-header">Profile</div>
              <div class="info-details">
                <span class="info-name">{{barber.fullName}}</span>
                <span class="info-stars">
                  <ion-icon
                    name="star"
                    [ngClass]="barber.numRatings <= 3 ? 'stars-less-opaque' : ''"
                    *ngFor="let _ of toRange(roundedRating())"
                  ></ion-icon>
                </span>
              </div>

              <div class="info-link">This is not a Pro on your account.</div>
            </div>

            <div class="booking-module" *ngIf="barber.businessID == userService.business.id">
              <div class="info-header">Manage profile</div>
              <div class="info-details">
                <span class="info-name">{{barber.fullName}}</span>
                <span class="info-stars">
                  <ion-icon
                    name="star"
                    [ngClass]="barber.numRatings <= 3 ? 'stars-less-opaque' : ''"
                    *ngFor="let _ of toRange(roundedRating())"
                  ></ion-icon>
                </span>
              </div>

              <div class="info-link" *ngIf="barber.active && !barber.inDemoMode_BusinessProOnly">{{proLink()}}</div>

              <div class="info-link" *ngIf="barber.active && barber.inDemoMode_BusinessProOnly">
                Profile is in Demo Mode. Message an Admin to activate.
              </div>

              <div class="info-link" *ngIf="!barber.active && barber.completedOnboarding">Profile deactivated.</div>

              <div class="info-link" *ngIf="!barber.active && !barber.completedOnboarding">Currently onboarding.</div>

              <div class="bottom-buttons">
                <p class="bottom-button view-admin" (click)="viewAsAdmin()">View Pro's full settings</p>
              </div>
            </div>
          </div>
        </div>

        <div class="biography">
          <p class="section-header-text">Biography</p>
          <p id="barber-prof-bio" *ngIf="barber.bio">"{{barber?.bio}}" - {{barber.firstName}}</p>
          <p id="barber-prof-bio" *ngIf="!barber.bio">No biography written yet.</p>
          <p id="barber-prof-certification" *ngIf="barber?.experienceStartYear">
            Shortcut Certified&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{ yearsSince( barber?.experienceStartYear )}}+ Years
            Experience
          </p>
          <p>Book now.</p>
        </div>

        <ion-item
          lines="none"
          class="chat-item"
          (click)="goToChat()"
          *ngIf="barber.active && !deviceService.isMobile && !eventID"
        >
          <ion-icon slot="start" name="chatbubbles" color="chatblue"></ion-icon>
          <ion-label>
            <span class="title"
              >{{userService.isBusinessAccount() ? ('Chat with ' + barber?.firstName) : 'Schedule through chat'}}</span
            >
            <p>{{barber.firstName}} was last active {{barberLastActiveDate()}}.</p>
          </ion-label>
          <ion-icon slot="end" name="chevron-forward-outline" class="SC-edit-icon"></ion-icon>
        </ion-item>

        <div *ngIf="barber?.acceptOnlyCustomAddress" class="only-custom-address-section">
          <hr />
          <div class="content-container">
            <ion-icon name="home" color="grey"></ion-icon>
            <span class="custom-address-text">{{barber?.firstName}} works out of their own home.</span>
          </div>
        </div>

        <hr id="barber-bio-post-hr" />

        <!-- REVIEWS -->

        <div id="barber-reviews-section" *ngIf="barber?.curatedReviews && barber?.curatedReviews.length">
          <h4 class="section-header-text">Client reviews</h4>

          <div *ngFor="let review of barber.curatedReviews; let last = last">
            <ion-item lines="none" class="review-item">
              <ion-thumbnail slot="start" style="display: flex; align-items: center">
                <img
                  [src]="review.thumbnail || placeholderImg"
                  class="SC-round-thumb"
                  style="width: 40px !important; height: 40px !important"
                />
              </ion-thumbnail>
              <ion-label>
                {{review.firstName}}
                <p>{{mmddyyDate(review.date)}}</p>
                <span class="review-stars">
                  <ion-icon name="star" *ngFor="let _ of toRange(review.rating)"></ion-icon>
                </span>
              </ion-label>
            </ion-item>
            <p class="review-message">{{review.message}}</p>

            <hr class="margined-divider" *ngIf="!last" />
          </div>
        </div>

        <div *ngIf="barber?.numRatings > 3" id="show-more-reviews-div" class="SC-clickable" (click)="showMoreReviews()">
          <span id="show-more-reviews-text" *ngIf="barber?.curatedReviews && barber?.curatedReviews.length"
            >Show more reviews</span
          >
          <span id="show-more-reviews-text" *ngIf="!barber?.curatedReviews || !barber?.curatedReviews.length"
            >Show reviews</span
          >
          <hr />
        </div>

        <!-- PHOTOS -->

        <div id="barber-photos-section" *ngIf="photos && photos.length">
          <!-- <hr style="margin-bottom: 20px" *ngIf="photos"> -->
          <h4 class="section-header-text">{{photos.length}} photos</h4>

          <div scrollX="true" id="photo-scroller">
            <img
              *ngFor="let photo of photos; let i = index"
              class="profile-photo SC-clickable"
              (load)="photoLoaded($event, photo)"
              (click)="photoTapped(photo, i)"
              [src]="photo.url"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="panel-exterior">
      <div class="right-panel" *ngIf="!userService.isBusiness && !deviceService.isMobile">
        <div class="booking-module">
          <div class="info-header">Book {{barber.firstName}}</div>
          <div class="info-details">
            <span class="info-name">{{barber.fullName}}</span>
            <span class="info-stars">
              <ion-icon
                name="star"
                [ngClass]="barber.numRatings <= 3 ? 'stars-less-opaque' : ''"
                *ngFor="let _ of toRange(roundedRating())"
              ></ion-icon>
            </span>
          </div>

          <div *ngIf="eventID && eventInfo">
            <!-- EVENT -->

            <div class="info-time">
              <span class="info-event-name">{{eventInfo.name}}</span>
            </div>

            <div class="info-time">{{ displayDate(eventInfo.startTime) }}</div>

            <div *ngIf="eventSelectedService">
              <div class="selector hover-red" (click)="openServices()">
                <ion-item lines="none">
                  <ion-icon slot="start" name="cut" color="lightgrey" class="start-icon"></ion-icon>
                  <ion-label>
                    {{ eventSelectedService ? eventSelectedService.serviceTitle : 'Select a service' }}
                  </ion-label>
                  <ion-icon slot="end" name="chevron-down-outline" class="dropdown-arrow"></ion-icon>
                </ion-item>
              </div>
            </div>

            <div class="info-time" *ngIf="eventSelectedService && (!eventTimeslots || !eventTimeslots.length)">
              <hr />
              No timeslots available for this service.<br />
              <span class="join-waitlist" (click)="joinWaitlist()">Join our waitlist</span> for updates.
            </div>

            <div *ngIf="eventTimeslots && eventTimeslots.length">
              <div class="timeslots">
                <ion-card
                  *ngFor="let timeslot of eventTimeslots"
                  class="time-card"
                  (click)="eventTimeslotPressed(timeslot)"
                  [ngClass]="eventSelectedTimeslot.startTime == timeslot.startTime ? 'highlighted-time-card' : ''"
                >
                  <ion-card-content>
                    <ion-icon name="lock" *ngIf="timeslot.locked"></ion-icon>
                    <p>{{ getDisplayStringForTimeslotDate(timeslot.startTime) }}</p>
                  </ion-card-content>
                </ion-card>
              </div>
            </div>

            <div *ngIf="eventSelectedService && eventTimeslots && eventTimeslots.length" class="book-button">
              <ion-button
                color="marine"
                (click)="bookEventPressed()"
                class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall"
                style="text-transform: none"
                >Select and continue</ion-button
              >
            </div>

            <div *ngIf="!eventSelectedService" class="book-button">
              <ion-button
                color="marine"
                (click)="openServices()"
                class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall"
                style="text-transform: none"
                >Select a service</ion-button
              >
            </div>
          </div>

          <div *ngIf="!eventID">
            <!-- IN HOME -->
            <div class="info-time" *ngIf="barber.active && displayTimeslots">
              {{ displayDate(apptCreator.apptTime.date) }} at {{
              getDisplayStringForTimeslotDate(apptCreator.apptTime.date) }}
            </div>
            <div class="info-time" *ngIf="barber.active && !displayTimeslots">Available for services</div>
            <div class="unavailable-text" *ngIf="!barber.active">
              {{barber.firstName}} is unavailable for services at this time. Please check back soon.
            </div>

            <div *ngIf="barber.active && displayTimeslots">
              <div class="selector hover-red" (click)="openServices()">
                <ion-item lines="none">
                  <ion-icon slot="start" name="cut" color="lightgrey" class="start-icon"></ion-icon>
                  <ion-label>
                    {{ apptCreator.selectedServiceTypeList.items.length ? apptCreator.selectedServiceTypeList.text :
                    'Select a service' }}
                  </ion-label>
                  <ion-icon slot="end" name="chevron-down-outline" class="dropdown-arrow"></ion-icon>
                </ion-item>
              </div>

              <div class="selector" [ngClass]="datePickerOpen ? '' : 'hover-red'">
                <ion-item lines="none" (click)="changeAvailDate()">
                  <ion-icon slot="start" name="calendar" color="lightgrey" class="start-icon"></ion-icon>
                  <ion-label> {{ displayDate(selectedTimeslotDate) }} </ion-label>
                  <ion-icon slot="end" name="chevron-down-outline" class="dropdown-arrow"></ion-icon>
                </ion-item>

                <div class="selector-date-options" *ngIf="datePickerOpen">
                  <ion-item lines="none" (click)="closeDatePicker()" class="active-date">
                    <ion-icon slot="start" name="calendar" color="lightgrey" class="start-icon"></ion-icon>
                    <ion-label> {{ displayDate(selectedTimeslotDate) }} </ion-label>
                    <ion-icon slot="end" name="chevron-down-outline" class="dropdown-arrow"></ion-icon>
                  </ion-item>

                  <div class="date-options">
                    <div *ngFor="let date of availData.dates" (click)="selectAvailDate(date)">
                      <ion-item lines="none" [ngClass]="datesEqual(selectedTimeslotDate, date) ? 'date-selected' : ''">
                        <ion-label> {{ displayDate(date) }} </ion-label>
                        <ion-icon
                          slot="end"
                          name="checkmark"
                          class="checkmark-icon"
                          *ngIf="datesEqual(selectedTimeslotDate, date)"
                        ></ion-icon>
                      </ion-item>
                    </div>
                  </div>
                </div>
              </div>

              <div class="custom-address-container" *ngIf="showCustomAddress">
                <ion-icon name="home" class="inline"></ion-icon>
                <p>{{ availData.customAddress | address }}</p>
              </div>

              <div class="timeslots">
                <ion-card
                  *ngFor="let timeslot of displayTimeslots"
                  class="time-card"
                  (click)="availTimeslotPressed(timeslot)"
                  [ngClass]="apptCreator.apptTime.date == timeslot.date ? 'highlighted-time-card' : ''"
                >
                  <ion-card-content>
                    <ion-icon name="lock" *ngIf="timeslot.locked"></ion-icon>
                    <ion-icon name="pin" *ngIf="timeslot.unavailableInZip"></ion-icon>
                    <ion-icon name="home" *ngIf="timeslot.useCustomAddress"></ion-icon>
                    <p>{{ getDisplayStringForTimeslotDate(timeslot.date) }}</p>
                  </ion-card-content>
                </ion-card>
              </div>
            </div>

            <span *ngIf="barber.active && apptCreator.selectedServiceTypeList.items.length">
              <div *ngIf="!apptCreator.address.zip.length" class="book-button">
                <ion-button
                  color="marine"
                  (click)="openAddress($event)"
                  class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall"
                  style="text-transform: none"
                  >Please enter your address</ion-button
                >
              </div>

              <div
                *ngIf="apptCreator.address.zip.length && !displayTimeslots && !userService.isBusiness"
                class="book-button"
              >
                <ion-button
                  color="marine"
                  (click)="goToChat()"
                  class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall"
                  style="text-transform: none"
                  >Chat with {{barber?.firstName}} to book</ion-button
                >
              </div>

              <div *ngIf="apptCreator.address.zip.length && displayTimeslots" class="book-button">
                <ion-button
                  color="marine"
                  (click)="bookPressed()"
                  class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall"
                  style="text-transform: none"
                  >Select and continue</ion-button
                >
              </div>
            </span>

            <span *ngIf="barber.active && !apptCreator.selectedServiceTypeList.items.length">
              <div class="book-button">
                <ion-button
                  color="marine"
                  (click)="openServices()"
                  class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall"
                  style="text-transform: none"
                  >Select a service</ion-button
                >
              </div>
            </span>
          </div>
        </div>
      </div>

      <div class="right-panel" *ngIf="!userService.isBusiness && deviceService.isMobile">
        <div class="booking-module">
          <div class="info-header">Book {{barber.firstName}}</div>
          <div class="info-details" *ngIf="!eventID">
            <span class="info-name">{{barber.fullName}}</span>
            <span class="info-stars">
              <ion-icon
                name="star"
                [ngClass]="barber.numRatings <= 3 ? 'stars-less-opaque' : ''"
                *ngFor="let _ of toRange(roundedRating())"
              ></ion-icon>
            </span>
          </div>
          <div class="info-event-details" *ngIf="eventID && eventInfo">
            <span class="info-event-name">{{eventInfo.name}}</span>
          </div>
          <div class="unavailable-text" *ngIf="!barber.active">
            {{barber.firstName}} is unavailable for services at this time. Please check back soon.
          </div>

          <span *ngIf="barber.active">
            <div class="book-button">
              <ion-button
                color="marine"
                (click)="openAppLink()"
                class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall"
                style="text-transform: none"
                >Book {{barber?.firstName}} in Shortcut</ion-button
              >
            </div>
          </span>
        </div>
      </div>

      <!-- BUSINESS PRO SETTINGS -->
      <div class="right-panel" *ngIf="userService.business">
        <div class="booking-module" *ngIf="barber.businessID !== userService.business.id">
          <div class="info-header">Profile</div>
          <div class="info-details">
            <span class="info-name">{{barber.fullName}}</span>
            <span class="info-stars">
              <ion-icon
                name="star"
                [ngClass]="barber.numRatings <= 3 ? 'stars-less-opaque' : ''"
                *ngFor="let _ of toRange(roundedRating())"
              ></ion-icon>
            </span>
          </div>

          <div class="info-link">This is not a Pro on your account.</div>
        </div>

        <div class="booking-module" *ngIf="barber.businessID == userService.business.id">
          <div class="info-header">Manage profile</div>
          <div class="info-details">
            <span class="info-name">{{barber.fullName}}</span>
            <span class="info-stars">
              <ion-icon
                name="star"
                [ngClass]="barber.numRatings <= 3 ? 'stars-less-opaque' : ''"
                *ngFor="let _ of toRange(roundedRating())"
              ></ion-icon>
            </span>
          </div>

          <div class="info-link" *ngIf="barber.active && !barber.inDemoMode_BusinessProOnly">{{proLink()}}</div>

          <div class="info-link" *ngIf="barber.active && barber.inDemoMode_BusinessProOnly">
            Profile is in Demo Mode. Message an Admin to activate.
          </div>

          <div class="info-link" *ngIf="!barber.active && barber.completedOnboarding">Profile deactivated.</div>

          <div class="info-link" *ngIf="!barber.active && !barber.completedOnboarding">Currently onboarding.</div>

          <div class="bottom-buttons">
            <p class="bottom-button view-admin" (click)="viewAsAdmin()">View Pro's full settings</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>
